import { render, staticRenderFns } from "./BusinessServices.vue?vue&type=template&id=636df7ec&scoped=true&"
import script from "./BusinessServices.vue?vue&type=script&lang=js&"
export * from "./BusinessServices.vue?vue&type=script&lang=js&"
import style0 from "./BusinessServices.vue?vue&type=style&index=0&id=636df7ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636df7ec",
  null
  
)

export default component.exports